module.exports = __webpack_public_path__ + "static/media/blue_light_arrow.465c4b0f.png";